import refreshIcon from '../assets/images/icons/refresh.png'

const GenericRefreshButton = ({ onClick }) => {

  const normalShadow = '0 1px 8px rgba(0,0,0,0.30)'

  return (
    <button
      type="button"
      onClick={(e) => {
        const img = e.currentTarget.querySelector('img')

        if (img) {
          img.style.transition = 'transform 0.8s linear'
          img.style.transform = 'rotate(360deg)'

          setTimeout(() => {
            img.style.transition = ''
            img.style.transform = ''
          }, 400)
        }

        e.currentTarget.blur()
        onClick?.()
      }}
      style={{
        border: '1.5px solid #107c6b',
        background: '#f5f5f5',
        borderRadius: 6,
        height: 24,
        width: 36,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: normalShadow,
        transition: 'transform 0.05s ease, box-shadow 0.1s ease',
        marginTop: 5,
        outline: 'none'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#2da9a4'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#f5f5f5'
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = normalShadow
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = 'scale(0.96)'
        e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = normalShadow
      }}
    >
      <img
        src={refreshIcon}
        alt="refresh"
        style={{
          width: 16,
          height: 16,
          pointerEvents: 'none'
        }}
      />
    </button>
  )
}

export default GenericRefreshButton